var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _vm.showDialog
        ? _c("ModalFullScreen", {
            attrs: { title: _vm.modalTitle },
            on: { close: _vm.closeModal },
            scopedSlots: _vm._u(
              [
                {
                  key: "titleLine",
                  fn: function () {
                    return [
                      _c("FormToggle", {
                        staticClass: "mr-5",
                        attrs: {
                          label: "Active",
                          "react-switch-label": "",
                          label_wrapper: "",
                          onColor: "#1890ff",
                          labelLeft: "",
                        },
                        model: {
                          value: _vm.posting.active,
                          callback: function ($$v) {
                            _vm.$set(_vm.posting, "active", $$v)
                          },
                          expression: "posting.active",
                        },
                      }),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "content",
                  fn: function () {
                    return [
                      _c(
                        "form",
                        {
                          on: {
                            submit: function ($event) {
                              $event.preventDefault()
                              return _vm.submit.apply(null, arguments)
                            },
                          },
                        },
                        [
                          _c("ValidationObserver", {
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function ({ invalid, dirty }) {
                                    return [
                                      _c(
                                        "ModalContent",
                                        {
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "actions",
                                                fn: function () {
                                                  return [
                                                    _c("UIButton", {
                                                      staticClass: "mr-3",
                                                      attrs: {
                                                        variant: "outline",
                                                        buttonText: "Cancel",
                                                        id: "cancelPosting",
                                                      },
                                                      on: {
                                                        click: _vm.closeModal,
                                                      },
                                                    }),
                                                    _vm.data
                                                      ? _c("UIButton", {
                                                          attrs: {
                                                            type: "submit",
                                                            id: "submiytPosting",
                                                            disabled: invalid,
                                                            buttonText:
                                                              "Update",
                                                          },
                                                        })
                                                      : _c("UIButton", {
                                                          attrs: {
                                                            type: "submit",
                                                            id: "createNewPostingJob",
                                                            disabled:
                                                              invalid || !dirty,
                                                            buttonText:
                                                              "Create",
                                                          },
                                                        }),
                                                  ]
                                                },
                                                proxy: true,
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        },
                                        [
                                          _c("RadioButtonGroup", {
                                            staticClass: "mb-4",
                                            attrs: {
                                              options: _vm.publicTypeOptions,
                                              name: "public",
                                            },
                                            model: {
                                              value: _vm.posting.public,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.posting,
                                                  "public",
                                                  $$v
                                                )
                                              },
                                              expression: "posting.public",
                                            },
                                          }),
                                          _c("ValidationProvider", {
                                            attrs: {
                                              rules: "required_field",
                                              name: "Job title",
                                              immediate: _vm.isEditing,
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function ({ errors }) {
                                                    return [
                                                      _c("FormGroup", {
                                                        attrs: {
                                                          errors: errors,
                                                          title: "Job Title*",
                                                          name: "job_title",
                                                          placeholder:
                                                            "Enter title",
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.posting
                                                              .job_title,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.posting,
                                                              "job_title",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "posting.job_title",
                                                        },
                                                      }),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          }),
                                          _c(
                                            "FormGroup",
                                            {
                                              attrs: { title: "Country" },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "title",
                                                    fn: function () {
                                                      return [
                                                        _c(
                                                          "p",
                                                          {
                                                            staticClass: "pb-2",
                                                          },
                                                          [_vm._v("Country")]
                                                        ),
                                                      ]
                                                    },
                                                    proxy: true,
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            },
                                            [
                                              _c("ProfileCountrySelect", {
                                                model: {
                                                  value: _vm.posting.country,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.posting,
                                                      "country",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "posting.country",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _c("RegionInput", {
                                            attrs: {
                                              countries: _vm.posting.country,
                                            },
                                            model: {
                                              value: _vm.posting.state,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.posting,
                                                  "state",
                                                  $$v
                                                )
                                              },
                                              expression: "posting.state",
                                            },
                                          }),
                                          _c("ValidationProvider", {
                                            attrs: {
                                              name: "City",
                                              rules: "name_with_spaces",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function ({ errors }) {
                                                    return [
                                                      _c("FormGroup", {
                                                        attrs: {
                                                          title: "City",
                                                          placeholder:
                                                            "Enter city",
                                                          errors: errors,
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.posting.city,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.posting,
                                                              "city",
                                                              typeof $$v ===
                                                                "string"
                                                                ? $$v.trim()
                                                                : $$v
                                                            )
                                                          },
                                                          expression:
                                                            "posting.city",
                                                        },
                                                      }),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          }),
                                          _vm.canEditManager
                                            ? _c("ValidationProvider", {
                                                attrs: { name: "manager" },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "default",
                                                      fn: function ({
                                                        errors,
                                                        failed,
                                                      }) {
                                                        return [
                                                          _c(
                                                            "FormGroup",
                                                            {
                                                              attrs: {
                                                                errors: errors,
                                                                name: "manager",
                                                              },
                                                              scopedSlots:
                                                                _vm._u(
                                                                  [
                                                                    {
                                                                      key: "title",
                                                                      fn: function () {
                                                                        return [
                                                                          _vm._v(
                                                                            " Manager "
                                                                          ),
                                                                        ]
                                                                      },
                                                                      proxy: true,
                                                                    },
                                                                  ],
                                                                  null,
                                                                  true
                                                                ),
                                                            },
                                                            [
                                                              _c(
                                                                "ManagersMultiselect",
                                                                {
                                                                  attrs: {
                                                                    value:
                                                                      _vm.managersIds,
                                                                    invalid:
                                                                      failed,
                                                                    multiple: false,
                                                                    placeholder:
                                                                      "Select a manager",
                                                                    title:
                                                                      "Manager",
                                                                  },
                                                                  on: {
                                                                    input:
                                                                      _vm.handleManagerInput,
                                                                  },
                                                                }
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                        ]
                                                      },
                                                    },
                                                  ],
                                                  null,
                                                  true
                                                ),
                                              })
                                            : _vm._e(),
                                          _c(
                                            "div",
                                            { staticClass: "flex" },
                                            [
                                              _c("ValidationProvider", {
                                                class: [
                                                  _vm.isContractEmployment
                                                    ? "w-7/12 mr-4"
                                                    : "w-full",
                                                ],
                                                attrs: {
                                                  name: "Employment Type",
                                                  rules: "required_field",
                                                  immediate: _vm.isEditing,
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "default",
                                                      fn: function ({
                                                        errors,
                                                        failed,
                                                      }) {
                                                        return [
                                                          _c(
                                                            "FormGroup",
                                                            {
                                                              attrs: {
                                                                errors: errors,
                                                              },
                                                              scopedSlots:
                                                                _vm._u(
                                                                  [
                                                                    {
                                                                      key: "title",
                                                                      fn: function () {
                                                                        return [
                                                                          _vm._v(
                                                                            " Employment Type * "
                                                                          ),
                                                                        ]
                                                                      },
                                                                      proxy: true,
                                                                    },
                                                                  ],
                                                                  null,
                                                                  true
                                                                ),
                                                            },
                                                            [
                                                              _c(
                                                                "EmploymentTypeSelect",
                                                                {
                                                                  attrs: {
                                                                    value:
                                                                      _vm
                                                                        .posting
                                                                        .employment_type,
                                                                    invalid:
                                                                      failed,
                                                                    multiple: false,
                                                                  },
                                                                  on: {
                                                                    input:
                                                                      _vm.handleEmploymentTypeInput,
                                                                  },
                                                                }
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                        ]
                                                      },
                                                    },
                                                  ],
                                                  null,
                                                  true
                                                ),
                                              }),
                                              _vm.isContractEmployment
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "w-1/2 mt-4 pl-2 flex items-center",
                                                    },
                                                    [
                                                      _c("RadioButtonGroup", {
                                                        attrs: {
                                                          options:
                                                            _vm.durationTypeOptions,
                                                          name: "durationType",
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.posting
                                                              .duration_type,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.posting,
                                                              "duration_type",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "posting.duration_type",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                            ],
                                            1
                                          ),
                                          _vm.isContractEmployment
                                            ? _c(
                                                "div",
                                                { staticClass: "flex" },
                                                [
                                                  _vm.isDurationInterval
                                                    ? [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "flex justify-between w-full",
                                                          },
                                                          [
                                                            _c(
                                                              "ValidationProvider",
                                                              {
                                                                staticClass:
                                                                  "w-6/12 mr-3",
                                                                attrs: {
                                                                  vid: "start_date",
                                                                  rules:
                                                                    "required_field|noPastDate",
                                                                  name: "Start Date",
                                                                  immediate:
                                                                    _vm.isEditing,
                                                                },
                                                                scopedSlots:
                                                                  _vm._u(
                                                                    [
                                                                      {
                                                                        key: "default",
                                                                        fn: function ({
                                                                          errors,
                                                                          failed,
                                                                        }) {
                                                                          return [
                                                                            _c(
                                                                              "FormGroup",
                                                                              {
                                                                                attrs:
                                                                                  {
                                                                                    errors:
                                                                                      errors,
                                                                                    name: "start_date",
                                                                                  },
                                                                                scopedSlots:
                                                                                  _vm._u(
                                                                                    [
                                                                                      {
                                                                                        key: "title",
                                                                                        fn: function () {
                                                                                          return [
                                                                                            _vm._v(
                                                                                              " Start Date* "
                                                                                            ),
                                                                                          ]
                                                                                        },
                                                                                        proxy: true,
                                                                                      },
                                                                                    ],
                                                                                    null,
                                                                                    true
                                                                                  ),
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "FormDatepicker",
                                                                                  {
                                                                                    attrs:
                                                                                      {
                                                                                        name: "start date",
                                                                                        invalid:
                                                                                          failed,
                                                                                      },
                                                                                    model:
                                                                                      {
                                                                                        value:
                                                                                          _vm
                                                                                            .posting
                                                                                            .start_date,
                                                                                        callback:
                                                                                          function (
                                                                                            $$v
                                                                                          ) {
                                                                                            _vm.$set(
                                                                                              _vm.posting,
                                                                                              "start_date",
                                                                                              $$v
                                                                                            )
                                                                                          },
                                                                                        expression:
                                                                                          "posting.start_date",
                                                                                      },
                                                                                  }
                                                                                ),
                                                                              ],
                                                                              1
                                                                            ),
                                                                          ]
                                                                        },
                                                                      },
                                                                    ],
                                                                    null,
                                                                    true
                                                                  ),
                                                              }
                                                            ),
                                                            _c(
                                                              "ValidationProvider",
                                                              {
                                                                staticClass:
                                                                  "w-6/12",
                                                                attrs: {
                                                                  rules:
                                                                    "noBeforeDate:@start_date,@ongoing|required_field",
                                                                  name: "End Date",
                                                                  immediate:
                                                                    _vm.isEditing,
                                                                },
                                                                scopedSlots:
                                                                  _vm._u(
                                                                    [
                                                                      {
                                                                        key: "default",
                                                                        fn: function ({
                                                                          errors,
                                                                          failed,
                                                                        }) {
                                                                          return [
                                                                            _c(
                                                                              "FormGroup",
                                                                              {
                                                                                attrs:
                                                                                  {
                                                                                    errors:
                                                                                      errors,
                                                                                    name: "end_date",
                                                                                  },
                                                                                scopedSlots:
                                                                                  _vm._u(
                                                                                    [
                                                                                      {
                                                                                        key: "title",
                                                                                        fn: function () {
                                                                                          return [
                                                                                            _vm._v(
                                                                                              " End Date* "
                                                                                            ),
                                                                                          ]
                                                                                        },
                                                                                        proxy: true,
                                                                                      },
                                                                                    ],
                                                                                    null,
                                                                                    true
                                                                                  ),
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "FormDatepicker",
                                                                                  {
                                                                                    attrs:
                                                                                      {
                                                                                        name: "end_date",
                                                                                        calendarClass:
                                                                                          "right-0 sm:right-0 sm:left-auto left-0 sm:left-auto",
                                                                                        invalid:
                                                                                          failed,
                                                                                      },
                                                                                    model:
                                                                                      {
                                                                                        value:
                                                                                          _vm
                                                                                            .posting
                                                                                            .end_date,
                                                                                        callback:
                                                                                          function (
                                                                                            $$v
                                                                                          ) {
                                                                                            _vm.$set(
                                                                                              _vm.posting,
                                                                                              "end_date",
                                                                                              $$v
                                                                                            )
                                                                                          },
                                                                                        expression:
                                                                                          "posting.end_date",
                                                                                      },
                                                                                  }
                                                                                ),
                                                                              ],
                                                                              1
                                                                            ),
                                                                          ]
                                                                        },
                                                                      },
                                                                    ],
                                                                    null,
                                                                    true
                                                                  ),
                                                              }
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    : [
                                                        _c(
                                                          "ValidationProvider",
                                                          {
                                                            staticClass:
                                                              "w-9/12",
                                                            attrs: {
                                                              name: "Duration",
                                                              rules:
                                                                "required|min_value:0",
                                                              vid: "duration",
                                                              immediate:
                                                                _vm.isEditing,
                                                            },
                                                            scopedSlots: _vm._u(
                                                              [
                                                                {
                                                                  key: "default",
                                                                  fn: function ({
                                                                    errors,
                                                                  }) {
                                                                    return [
                                                                      _c(
                                                                        "FormGroup",
                                                                        {
                                                                          attrs:
                                                                            {
                                                                              errors:
                                                                                errors,
                                                                              name: "duration",
                                                                            },
                                                                          scopedSlots:
                                                                            _vm._u(
                                                                              [
                                                                                {
                                                                                  key: "title",
                                                                                  fn: function () {
                                                                                    return [
                                                                                      _vm._v(
                                                                                        " Duration (" +
                                                                                          _vm._s(
                                                                                            _vm
                                                                                              .posting
                                                                                              .durationUnit
                                                                                          ) +
                                                                                          ") * "
                                                                                      ),
                                                                                    ]
                                                                                  },
                                                                                  proxy: true,
                                                                                },
                                                                              ],
                                                                              null,
                                                                              true
                                                                            ),
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "FormInput",
                                                                            {
                                                                              attrs:
                                                                                {
                                                                                  type: "number",
                                                                                  placeholder:
                                                                                    "duration",
                                                                                },
                                                                              model:
                                                                                {
                                                                                  value:
                                                                                    _vm
                                                                                      .posting
                                                                                      .duration,
                                                                                  callback:
                                                                                    function (
                                                                                      $$v
                                                                                    ) {
                                                                                      _vm.$set(
                                                                                        _vm.posting,
                                                                                        "duration",
                                                                                        $$v
                                                                                      )
                                                                                    },
                                                                                  expression:
                                                                                    "posting.duration",
                                                                                },
                                                                            }
                                                                          ),
                                                                        ],
                                                                        1
                                                                      ),
                                                                    ]
                                                                  },
                                                                },
                                                              ],
                                                              null,
                                                              true
                                                            ),
                                                          }
                                                        ),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "w-3/12 mt-4 flex items-center",
                                                          },
                                                          [
                                                            _c(
                                                              "RadioButtonGroup",
                                                              {
                                                                attrs: {
                                                                  options:
                                                                    _vm.durationUnitOptions,
                                                                  name: "durationUnit",
                                                                },
                                                                model: {
                                                                  value:
                                                                    _vm.posting
                                                                      .durationUnit,
                                                                  callback:
                                                                    function (
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        _vm.posting,
                                                                        "durationUnit",
                                                                        $$v
                                                                      )
                                                                    },
                                                                  expression:
                                                                    "posting.durationUnit",
                                                                },
                                                              }
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                ],
                                                2
                                              )
                                            : _vm._e(),
                                          _c(
                                            "FormGroup",
                                            {
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "title",
                                                    fn: function () {
                                                      return [
                                                        _vm._v(" Industries "),
                                                      ]
                                                    },
                                                    proxy: true,
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            },
                                            [
                                              _c("IndustriesMultiselect", {
                                                attrs: { limit: 10 },
                                                model: {
                                                  value: _vm.posting.industries,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.posting,
                                                      "industries",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "posting.industries",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "FormGroup",
                                            {
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "title",
                                                    fn: function () {
                                                      return [
                                                        _vm._v(" Skills "),
                                                      ]
                                                    },
                                                    proxy: true,
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            },
                                            [
                                              _c("SkillsMultiselect", {
                                                attrs: { limit: 10 },
                                                model: {
                                                  value: _vm.posting.skillsIds,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.posting,
                                                      "skillsIds",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "posting.skillsIds",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "FormGroup",
                                            {
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "title",
                                                    fn: function () {
                                                      return [
                                                        _vm._v(" Description "),
                                                      ]
                                                    },
                                                    proxy: true,
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            },
                                            [
                                              _c("FormTextarea", {
                                                attrs: {
                                                  name: "description",
                                                  placeholder:
                                                    "Describe the Client",
                                                },
                                                model: {
                                                  value:
                                                    _vm.posting.description,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.posting,
                                                      "description",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "posting.description",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              2325491636
                            ),
                          }),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              3698113922
            ),
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }